import {combineReducers} from "redux";

import auth from "./authReducer";
import customer from "./customerReducer";
import invoices from "./invoicesReducer";
import profile from "./profileReducer";
import user from "./userReducer";
import register from './registerReducer'
import modal from './modalReducer'
import errors from './errorsReducer'
import filters from './filtersReducer'

const rootReducer = combineReducers({
    auth,
    customer,
    invoices,
    profile,
    user,
    register,
    modal,
    errors,
    filters
});

export default rootReducer;
